import { useCallback, useContext } from 'react';

import { PNLContext } from '../../../../providers/pnl-provider';

export const useExpandCollapseRows = () => {
  const {
    filters: { setExpandableRows },
  } = useContext(PNLContext);

  const collectIdsUpToLevel = (nodes: any[], maxLevel: number): string[] => {
    const ids: string[] = [];

    function traverse(node: any, level: number) {
      if (level > maxLevel) return;

      if (Array.isArray(node.children) && node.children.length > 0) {
        ids.push(node.id);
        node.children.forEach((child: any) => traverse(child, level + 1));
      }
    }

    nodes.forEach((n) => traverse(n, 0));
    return ids;
  };

  const expandAll = useCallback(
    (data: any[]) => {
      const ids = collectIdsUpToLevel(data, 2);
      setExpandableRows(ids);
    },
    [setExpandableRows],
  );

  const collapseAll = useCallback(
    (data: any[]) => {
      const level1Ids = collectIdsUpToLevel(data, 0);
      setExpandableRows(level1Ids);
    },
    [setExpandableRows],
  );

  return { expandAll, collapseAll };
};
